import { Group } from '@/components/_common';
import { usePurchaseItemsAddWorkOrderItems } from '@/core/domain/purchase/purchaseItem/PurchaseItem.hooks';
import { PurchaseItem } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Card } from 'antd';
import { Info } from 'react-feather';

interface Props {
  purchaseItem?: PurchaseItem;
  onFinish: VoidFunction;
}

export default function PurchaseItemCreateInWorkorder({
  purchaseItem,
  onFinish,
}: Props) {
  const purchaseItemAddWorkOrderItems = usePurchaseItemsAddWorkOrderItems();

  const handleSubmit = async () => {
    try {
      if (!purchaseItem) return;

      await purchaseItemAddWorkOrderItems.mutateAsync({
        purchaseItemIds: [purchaseItem.id],
      });

      onFinish();
    } catch {}
  };

  if (!hasPermissions([Authorities.MOVIMENTATION_PURCHASE_ITEM_EDIT]))
    return null;

  return (
    <Card style={{ borderRadius: 8, marginBottom: 24 }}>
      <Group align="start" gap={16}>
        <Info color="#1864ab" size={32} />
        <div>
          <p style={{ margin: 0, fontSize: '1.15rem' }}>
            Não tem a peça na Ordem de Serviço?
            <br />
            Utilize o item da compra para inserir na OS
          </p>

          <div style={{ marginTop: 16 }}>
            <Button
              type="primary"
              onClick={handleSubmit}
              loading={purchaseItemAddWorkOrderItems.isLoading}
            >
              Adicionar item na OS
            </Button>
          </div>
        </div>
      </Group>
    </Card>
  );
}
